/* External */
import { memo, useMemo } from 'react';
import PropTypes from 'prop-types';

/* Components */
import CardEpisode from '../CardEpisode';
import ScrollIntoViewIfFocused from '../ScrollIntoViewIfFocused';

/* Utils */
import { ScrollPosition } from '../ScrollView';
import { useItemData } from '../VirtualizedList';

function EpisodeSelectorRow({ index }) {
  const {
    episodes,
    focusRestorable,
    onEpisodeArrowPress,
    onEpisodeEnterPress,
  } = useItemData();

  const episode = useMemo(() => episodes?.get(index), [episodes, index]);

  return (
    <ScrollIntoViewIfFocused
      className={`dtv-html5-c-episode-selector__lane-card ${
        index === 0 ? 'dtv-html5-c-episode-selector__lane-card--first' : ''
      }`}
      position={ScrollPosition.CENTER}
    >
      <CardEpisode
        index={index}
        content={episode}
        focusRestorable={focusRestorable}
        onArrowPress={onEpisodeArrowPress}
        onEnterPress={onEpisodeEnterPress}
      />
    </ScrollIntoViewIfFocused>
  );
}

EpisodeSelectorRow.propTypes = {
  index: PropTypes.number.isRequired,
};

export default memo(EpisodeSelectorRow);
